<template>
  <div
    :class="{
      [size]: true,
      'h5-price-size-wrap': isH5,
      'price-size-wrap': !isH5,
    }"
  >
    <!-- 活动价+原价 -->
    <template v-if="activePrice && originPrice">
      <div class="active-price price" v-html="splitPrice(activePrice)"></div>
      <div class="origin-price price" v-html="splitPrice(originPrice)"></div>
    </template>
    <!-- 仅原价 -->
    <template v-else-if="originPrice">
      <div class="active-price price" v-html="splitPrice(originPrice)"></div>
    </template>
  </div>
</template>

<script>
import { splitPrice, isH5 } from "@saas/components";
export default {
  props: {
    originPrice: {
      type: Number,
      default: null,
    },
    activePrice: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "SL2",
    },
  },
  data: function () {
    return {
      splitPrice,
      isH5: isH5(),
    };
  },
};
</script>

<style lang="scss" scoped>
.price-size-wrap {
  display: flex;
  align-items: flex-end;
  .price {
    display: flex;
    font-family: AvenirLTPro !important;
  }
  ::v-deep .active-price {
    font-weight: 800;
    color: #ff265c;
    display: flex;
    align-items: flex-end;
    line-height: 1;
    margin-right: 3px;
    span {
      line-height: 1;
    }
  }
  ::v-deep .origin-price {
    font-weight: 500;
    color: #858687;
    text-decoration-line: line-through;
    line-height: 1;
    margin-right: 3px;
    .unit {
      font-weight: 400;
    }
  }
}
.price-size-wrap.SL1 {
  ::v-deep .active-price {
    font-size: 20px;
    .unit {
      font-size: 12px;
      margin-bottom: 2px;
    }
    .decimal {
      font-size: 12px;
      margin-bottom: 2px;
    }
  }
  .origin-price {
    font-size: 12px;
    margin-bottom: 2px;
  }
}
.price-size-wrap.SL2 {
  ::v-deep .active-price {
    font-size: 26px;
    .unit {
      font-size: 14px;
      margin-bottom: 2px;
    }
    .decimal {
      font-size: 14px;
      margin-bottom: 2px;
    }
  }
  ::v-deep .origin-price {
    font-size: 14px;
    margin-bottom: 2px;
  }
}
.price-size-wrap.ML1 {
  ::v-deep .active-price {
    font-size: 32px;
    .unit {
      font-size: 16px;
      margin-bottom: 4px;
    }
    .decimal {
      font-size: 16px;
      margin-bottom: 4px;
    }
  }
  ::v-deep .origin-price {
    font-size: 16px;
    margin-bottom: 4px;
  }
}

.h5-price-size-wrap {
  display: flex;
  align-items: flex-end;
  .price {
    display: flex;
    font-family: AvenirLTPro !important;
  }
  ::v-deep .active-price {
    font-weight: 800;
    color: #ff265c;
    display: flex;
    align-items: flex-end;
    line-height: 1;
    margin-right: 0.05rem;
    span {
      line-height: 1;
    }
  }
  ::v-deep .origin-price {
    font-weight: 500;
    color: #858687;
    text-decoration-line: line-through;
    line-height: 1;
    margin-right: 0.05rem;
    .unit {
      font-weight: 400;
    }
  }
}
.h5-price-size-wrap.ML1 {
  ::v-deep .active-price {
    font-size: 0.48rem;
    .unit {
      font-size: 0.24rem;
      margin-bottom: 0.04rem;
    }
    .decimal {
      font-size: 0.24rem;
      margin-bottom: 0.04rem;
    }
  }
  ::v-deep .origin-price {
    font-size: 0.24rem;
    margin-bottom: 0.04rem;
  }
}
.h5-price-size-wrap.ML2 {
  ::v-deep .active-price {
    font-size: 0.56rem;
    .unit {
      font-size: 0.28rem;
      margin-bottom: 0.04rem;
    }
    .decimal {
      font-size: 0.28rem;
      margin-bottom: 0.04rem;
    }
  }
  ::v-deep .origin-price {
    font-size: 0.28rem;
    margin-bottom: 0.04rem;
  }
}
.price-size-wrap.ML2 {
  ::v-deep .active-price {
    font-size: 32px;
    .unit {
      font-size: 16px;
      margin-bottom: 4px;
    }
    .decimal {
      font-size: 16px;
      margin-bottom: 4px;
    }
  }
  ::v-deep .origin-price {
    font-size: 16px;
    margin-bottom: 4px;
  }
}
</style>
